export const API_URL = 'https://localhost:4999';
export const API_ROUTES = {
  CONTACT: `/api/contact`,
};
